export default Object.freeze({
  customName: {
    title: 'Custom name',
    message:
      'Use Custom Group Name to specify a name for the output group. It does not affect your outputs.',
  },
  segmentControl: {
    title: 'Segment control',
    message:
      'When set to Single File, emits program as a single media resource (.ts) file, uses #EXT-X-BYTERANGE tags to index segment for playback.',
  },
  segmentLength: {
    title: 'Segment length',
    message:
      'Length of MPEG-2 Transport Stream segments to create (in seconds). Note that segments will end on the next keyframe after this number of seconds, so actual segment length may be longer.',
  },
  minSegmentLength: {
    title: 'Min segment length',
    message:
      'When set, Minimum Segment Size is enforced by looking ahead and back within the specified range for a nearby avail and extending the segment size if needed.',
  },
  outputNameModifier: {
    title: 'Output name modifier',
    message:
      'Use Name modifier to have the service add a string to the end of each output filename. You specify the base filename as part of your destination URI. When you create multiple outputs in the same output group, Name modifier is required.',
  },
  outputPreset: {
    title: 'Output preset',
    message:
      "Specify a set of preconfigured output settings to apply to this output. If there isn't a preset with the settings that you want, you can specify the output settings individually.",
  },
  outputFileName: {
    title: 'Output File Name',
    message: 'Use this field to specify outputs file name.',
  },
  outputFolderName: {
    title: 'Output Folder Name',
    message: 'Use this field to specify outputs folder name. (HLS Only)',
  },
  hlsSizeLength: {
    title: 'HLS List Size',
    message: 'The number of chunks that master file contains.',
  },
})
